export function SpecsLogo({ height = 25 }: { height?: number }) {
  return (
    <img
      src="https://res.cloudinary.com/dyuuf6gor/image/upload/v1693255147/gifts/specs-logo_wnfv8m.png"
      alt="Specs Logo"
      height={height}
      style={{ display: "block" }}
    />
  );
}
